import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [
    "titleInput",
    "typeInput",
    "fixedTypeWrapper",
    "fixedTypeInput",
    "fixedTypeLabel",
    "customFieldsWrapper",
    "hint"
  ]
  static values = { "hintsByFixedType": Object }

  connect() {
    this.updateForm()
  }

  updateForm() {
    this.updateInputsVisibility()
    this.updateFixedTypeHint()
  }

  fixedTypeChanged() {
    this.updateTitle()
    this.updateFixedTypeHint()
  }

  updateTitle() {
    const checkedFixedTypeRadio = this.getCheckedFixedTypeRadioInput()

    if (!checkedFixedTypeRadio)
      return

    const titleValue = this.fixedTypeLabelTargets.find(label => label.contains(checkedFixedTypeRadio)).textContent.trim()
    this.titleInputTarget.value = titleValue
  }

  updateInputsVisibility() {
    const checkedTypeRadio = this.getCheckedTypeRadioInput()
    if (!checkedTypeRadio)
      return

    const type = checkedTypeRadio.value

    this.fixedTypeWrapperTarget.classList.toggle("hidden!", type !== "fixed")
    this.customFieldsWrapperTarget.classList.toggle("hidden!", type !== "custom")
  }

  updateFixedTypeHint() {
    const checkedFixedTypeRadio = this.getCheckedFixedTypeRadioInput()
    if (!checkedFixedTypeRadio)
      return

    const fixedType = checkedFixedTypeRadio.value
    const hint = this.hintsByFixedTypeValue[fixedType]
    this.hintTarget.textContent = hint
  }

  getCheckedTypeRadioInput() {
    return this.typeInputTargets.find(radioButton => radioButton.checked)
  }

  getCheckedFixedTypeRadioInput() {
    return this.fixedTypeInputTargets.find(radioButton => radioButton.checked)
  }
}
